import { useQuery } from '@tanstack/react-query';

import { GlobalReactQueryOptions } from '../../../config';
import { SpocContextChangeResponse } from '../../../store/api';
import { fetchOrderRequiredSpoc } from '../../../api/orders/fetchOrderRequiredSpoc';
import { SpocRequiredFor } from './CheckRequiredSpoc';
import { log } from '../../utils/log';
import { UseQueryResult } from '../../../api/query-types';
import { fetchSelectionListRequiredSpoc } from '../../../api/selection-list/fetchSelectionListRequiredSpoc';
import { fetchRequiredLocalContentProductSpoc } from '../../../api/local-content/collection/product/fetchRequiredSpoc';

type RequiredSpocResponse = SpocContextChangeResponse;

type UseRequiredSpocQuery = UseQueryResult<'data', RequiredSpocResponse>;

const emptySpoc = {};
type FetchRequiredSpocFunc = (type: SpocRequiredFor, id: string) => Promise<RequiredSpocResponse>;

const getFetchFuncFor = (type: SpocRequiredFor): FetchRequiredSpocFunc => {
    switch (type) {
        case SpocRequiredFor.ORDER:
            return fetchOrderRequiredSpoc;
        case SpocRequiredFor.ORDERLIST:
            return fetchSelectionListRequiredSpoc;
        case SpocRequiredFor.LOCAL_CONTENT_PRODUCT:
            return fetchRequiredLocalContentProductSpoc;
        default:
            const error = new Error(`Invalid type "${type}" for SpocRequiredFor given!`);
            log.error(error);
            throw error;
    }
};

export const useRequiredSpocQuery = (type: SpocRequiredFor, id: string): UseRequiredSpocQuery => {
    const fetchFunc = getFetchFuncFor(type);

    const { data, ...result } = useQuery(
        ['requiredSpoc', type, id],
        () => fetchFunc(type, id),
        GlobalReactQueryOptions
    );

    return {
        ...result,
        data: data ?? emptySpoc
    };
};
